import React, { Component } from 'react'
import { Button } from 'antd'
import CustomTable from '../../../elements/Table/CustomTable'

import StatusFilter, { statusFilterMethod } from '../Group/TableComponents/StatusFilter'
import StatusCell from '../../../elements/Table/Cells/StatusCell'

function List(props) {
  const { list, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true
    },
    {
      Header: 'Name',
      accessor: 'name',
      style: { textAlign: 'left', paddingLeft: 20 },
      width: 250,
      Cell: ({ original, value }) => {
        return <a onClick={() => onShow(original, 'edit')}>{value}</a>
      },
    },
    {
      Header: 'Code',
      accessor: 'code',
      width: 150,
    },
    {
      Header: 'Type',
      accessor: 'type',
      width: 200,
    },
    {
      Header: 'Description',
      accessor: 'description',
      style: { textAlign: 'left', paddingLeft: 20 },
    },
    {
      Header: 'E-Mail',
      accessor: 'email',
      style: { textAlign: 'left', paddingLeft: 20 },
      width: 300,
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 200,
      Cell: StatusCell,
      filterMethod: statusFilterMethod,
      Filter: StatusFilter,
    },
  ]

  return (
    <CustomTable
      data={list}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          Create Group
        </Button>
      )}
      columns={columns}
      defaultSorted={[
        {
          id: 'name',
          desc: false,
        },
      ]}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
